import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  //here
  projectFilledButtonSx: {
    textTransform: "none !important",
    borderRadius: "5px !important",
    minHeight: 40,
    px: 2,
    backgroundColor: "#6C65D9 !important",
    color: "#EEEEEE !important",
    boxShadow: "none !important",
    "&:hover": {
      backgroundColor: "#5a54c4 !important",
      boxShadow: "none !important",
    },
  },
  filterDrawerTokens: {
    bg: "#0d1117 !important",
    bgElevated: "#161b22 !important",
    border: "rgba(255, 255, 255, 0.12) !important",
    textPrimary: "#f0f6fc !important",
    textSecondary: "rgba(255, 255, 255, 0.55) !important",
    accent: "#a855f7",
    accentHover: "#9333ea !important",
    delete: "#ef4444 !important",
  },
  projectOutlinedButtonSx: {
    textTransform: "none !important",
    borderRadius: "5px !important",
    minHeight: 40,
    px: 2,
    color: "#F9F9F9 !important",
    border: "2px solid #6C65D9 !important",
    whiteSpace: "nowrap !important",
    "&:hover": {
      border: "2px solid #6C65D9 !important",
      backgroundColor: "#252A38 !important",
    },
  },
  saveBtn: {
    textTransform: "none !important",
    color: "#F9F9F9 !important",
    "&:disabled": {
      color: "#606479 !important",
    },
  },
  selectStyle: {
    borderColor: "#606479 !important",
    backgroundColor: "#252A38 !important",
    color: "#F9F9F9 !important",
    "& .MuiSvgIcon-root": { color: "#606479" },
  },
  labelStyle: {
    color: "#606479",
    fontSize: 14,
    mb: 0.5,
    fontWeight: 500,
  },
}));

export default useStyles;
